// import React from "react";
// import { Col, Row } from "antd";
// import {
//   FacebookOutlined,
//   TwitterOutlined,
//   InstagramOutlined,
//   LinkedinOutlined,
// } from "@ant-design/icons";

// const AboutHKS = () => {
//   return (
//     <div style={{ padding: "50px", backgroundColor: "#f5f5f5" }}>
//       <Row gutter={32} align="middle">
//         <Col xs={24} md={16}>
//           <h2 style={{ fontSize: "32px", color: "#0d1a26" }}>ABOUT US</h2>
//           <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
//             <strong>HINDU KHATIK SAMAJ ECONOMIC DEVELOPMENT CORPORATION</strong>{" "}
//             is a dedicated initiative working toward the upliftment and
//             empowerment of the Hindu Khatik community. We aim to provide
//             structured welfare programs, improve access to resources, and enable
//             self-sustaining livelihoods.
//             <br />
//             <br />
//             Through strategic support such as grants, skill development, and
//             collaborations, we work to build a more inclusive, educated, and
//             economically resilient future for the community.
//           </p>

//           <div style={{ marginTop: "20px", display: "flex", gap: "15px" }}>
//             <a href="#" target="_blank" rel="noopener noreferrer">
//               <FacebookOutlined
//                 style={{ fontSize: "26px", color: "#3b5998" }}
//               />
//             </a>
//             <a href="#" target="_blank" rel="noopener noreferrer">
//               <TwitterOutlined style={{ fontSize: "26px", color: "#1DA1F2" }} />
//             </a>
//             <a href="#" target="_blank" rel="noopener noreferrer">
//               <InstagramOutlined
//                 style={{ fontSize: "26px", color: "#C13584" }}
//               />
//             </a>
//             <a href="#" target="_blank" rel="noopener noreferrer">
//               <LinkedinOutlined
//                 style={{ fontSize: "26px", color: "#0e76a8" }}
//               />
//             </a>
//           </div>
//         </Col>

//         <Col xs={24} md={8} style={{ textAlign: "center", marginTop: "30px" }}>
//           <img
//             src={`${process.env.PUBLIC_URL}/HKSLogo.png`}
//             alt="HKS Logo"
//             style={{ maxWidth: "100%", height: "auto" }}
//           />
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default AboutHKS;

import React, { useEffect } from 'react';
import { Col, Row } from "antd";
import GhatikLogo3 from "../../Images/GhatikLogo3.png";

const AboutHKS = () => {
  useEffect(() => {
    // Scroll to the top of the page when this component is mounted
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ backgroundColor: "#ffffff", padding:'150px',paddingTop:"20px",paddingBottom:"0px"}}>
      <p style={{ fontSize: "24px", color: "#0059AB",textDecoration:"underline", textAlign: "left", marginBottom: "60px", marginTop:'0px',paddingTop:'10px'}}>
        ABOUT US
      </p>
      <Row gutter={32} align="middle">
        <Col xs={24} md={8} style={{ textAlign: "center", marginBottom: "30px" }}>
          <img
            src={GhatikLogo3}
            alt="HKS Logo"
            style={{ Width: "300px", height: "300px" }}
          />
        </Col>

        <Col xs={24} md={16}>
          
          <p style={{ fontSize: "16px", lineHeight: "2" ,textAlign:"left" , marginLeft:"70px",marginBottom:"80px"}}>
            <strong>HINDU KHATIK SAMAJ ECONOMIC DEVELOPMENT CORPORATION is a dedicated initiative working toward the upliftment and empowerment of the Hindu Khatik community. We aim to provide structured welfare programs, improve access to resources, and enable self-sustaining livelihoods.
            <br/>Through strategic support such as grants, skill development, and collaborations, we work to build a more inclusive, educated, and economically resilient future for the community.</strong></p>
        </Col>
      </Row>

      {/* New Section */}
      <div style={{ marginTop: "50px" ,textAlign:"left", fontWeight:"bold"}}>
        <h3 style={{ fontSize: "20px", fontWeight:"bold",color: "#193367", textDecoration: "underline" }}>
          MAIN OBJECTS OF THE COMPANY TO BE PURSUED BY THE COMPANY ON ITS INCORPORATION:
        </h3>
        <ol style={{ fontSize: "16px", lineHeight: "1.8", paddingBottom: "0px", marginTop: "20px", paddingLeft: "20px", textAlign: "left", listStyleType: "none", counterReset: "item" }}>
            <li style={{ counterIncrement: "item", marginBottom: "10px" }}>
              <span style={{ marginRight: "8px" }}>{`1)`}</span>
              To provide an integrated empowered institution that would be responsible for planning, implementation and monitoring of the welfare, development, enhancement and other activities that would empower the Hindu Khatik Community in the State.
            </li>
            <li style={{ counterIncrement: "item", marginBottom: "10px" }}>
              <span style={{ marginRight: "8px" }}>{`2)`}</span>
              To provide grant/subsidy and soft loans to individuals from the Hindu Khatik community to support self-employment, business development, economic empowerment and to recover such loans.
            </li>
            <li style={{ counterIncrement: "item", marginBottom: "10px" }}>
              <span style={{ marginRight: "8px" }}>{`3)`}</span>
              To take up various activities, including but not limited to, financial resources, support, technical assistance, and managerial support to improve the economic, social, education and cultural condition of the Hindu Khatik community.
            </li>
            <li style={{ counterIncrement: "item", marginBottom: "10px" }}>
              <span style={{ marginRight: "8px" }}>{`4)`}</span>
              To support, assist, guide, promote, consultation, skill training and empower, facilitate the production, coordination, and supply of goods, materials, and equipment for the Hindu Khatik community.
            </li>
            <li style={{ counterIncrement: "item", marginBottom: "10px" }}>
              <span style={{ marginRight: "8px" }}>{`5)`}</span>
              To initiate and promote welfare schemes for the Hindu Khatik community in the state and prepare progress report for the same.
            </li>
          </ol>

      </div>
    </div>
  );
};

export default AboutHKS;
